import { xhrApiClient } from '@/config/xhrApiClient'

const postStripeIntent = async (payload: any) => {
    const { data } = await xhrApiClient.post(`/api/stripe-intent`, payload)
    return data
}

export default postStripeIntent
